/** @format */

import { IHomrRichContent } from '@shared/data-access/interfaces';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HomrContentService {
  /**
   * Default properties to ignore when checking if HOMR rich content should be displayed
   */
  private readonly DEFAULT_PROPS_TO_IGNORE = ['pdp3DImagery', 'enhancedProductCard'];

  /**
   * Checks if HOMR rich content has any non-empty property that should be displayed.
   * Recursively checks nested objects and ignores specific properties.
   */
  public shouldHomrRichContentBeDisplayed(
    obj: IHomrRichContent,
    propsToIgnore: string[] = this.DEFAULT_PROPS_TO_IGNORE,
  ): boolean {
    let hasNonEmptyProperty = false;
    for (const prop in obj) {
      if (!propsToIgnore.includes(prop)) {
        if (typeof obj[prop] === 'object' && obj[prop] !== null) {
          // Recursively check nested object
          if (this.shouldHomrRichContentBeDisplayed(obj[prop])) {
            hasNonEmptyProperty = true;
            break;
          }
        } else if (obj[prop] || (Array.isArray(obj[prop]) && obj[prop].length > 0)) {
          hasNonEmptyProperty = true;
          break;
        }
      }
    }
    return hasNonEmptyProperty;
  }
}
